import { use } from 'react';
import { AuthContext, type AuthContextValue } from '@/lib/authContext';

export const useAuth = (): AuthContextValue => {
  const context = use(AuthContext);
  if (!context) throw new Error('useAuth must be used inside <AuthProvider>');
  return context;
};
